import Button from "@/Components/Button/Button";
import Checkbox from "@/Components/Checkbox/Checkbox";
import Pin from "@/Components/Layout/Pin";
import Modal from "@/Components/Modal/Modal";
import SelectBox from "@/Components/Select/SelectBox";
import { useSetTableIds } from "@/Components/Tables/useTableIds";
import { useSetModal } from "@/shared/atoms/useModal";
import useCouriersHook from "@/shared/hooks/useCouriersHook";
import useIsAdmin from "@/shared/hooks/useIsAdmin";
import useOpenQrModal from "@/shared/hooks/useOpenQrModal";
import useUpdateOrdersStatus from "@/shared/hooks/useUpdateOrdersStatus";
import useAssignCourierToOrdersMutation from "@/shared/mutations/orders/useAssignCourierToOrdersMutation";
import useMapOrdersSettingsQuery from "@/shared/queries/mapOrders/useMapOrdersSettings";
import { ordersToIds } from "@/shared/utils/helpers";
import { CmsUsersResponse } from "@/shared/utils/interfaces";
import { FormEvent, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import useSelectedOrders from "./useSelectedOrders";

const MapOrdersSelectModal = (props) => {
  const isAdmin = useIsAdmin();
  const {
    data: { pin_code_check },
  } = useMapOrdersSettingsQuery();
  const update = useUpdateOrdersStatus();
  const [status, setStatus] = useState(true);
  const selected = useSelectedOrders();
  const setModal = useSetModal();
  const { t } = useTranslation();
  const setIds = useSetTableIds();
  const assign = useAssignCourierToOrdersMutation();
  const couriers = useCouriersHook();
  const openQr = useOpenQrModal();
  const [courier, setCourier] =
    useState<CmsUsersResponse | undefined>(undefined);
  const onSave = (e?: FormEvent<HTMLFormElement>, pin_code?: number) => {
    e?.preventDefault();

    if (courier) {
      const courierId = courier.item_id;
      const orders = ordersToIds(selected);
      assign.mutateAsync({ orders, courierId, pin_code }).then(() => {
        if (status) {
          const ids = ordersToIds(selected);
          update("enroute", ids);
        }
        if (status) {
          openQr(selected);
        }
        props?.onExit();
        setIds([]);
      });
    }
  };
  return (
    <Modal
      width={{ _: "90%", md: "90%" }}
      onExit={() => setModal("")}
      {...props}
    >
      <form id="1" onSubmit={onSave}>
        <div className="mb-[2rem] text-[2rem] font-semibold">
          {t("assignOrdersToDeliverer")}
        </div>
        <div className="mb-[2rem]">
          <Checkbox active={status} onChange={() => setStatus(!status)}>
            {t("setOrdersForEnroute")}
          </Checkbox>
        </div>
        <div className="mb-[3rem]">
          {(isAdmin || (pin_code_check ? courier === undefined : true)) && (
            <div>
              <Row>
                {couriers.map((c) => (
                  <Col xs={6} md={2} key={c.item_id}>
                    <SelectBox
                      onClick={() => setCourier(c)}
                      active={c.item_id === courier?.item_id}
                    >
                      {c.name}
                    </SelectBox>
                  </Col>
                ))}
              </Row>
            </div>
          )}

          {(isAdmin || pin_code_check === false) && (
            <Button isDisabled={courier === undefined}>{t("save")}</Button>
          )}

          {pin_code_check && courier !== undefined && !isAdmin && (
            <>
              <Button onClick={() => setCourier(undefined)}>
                {t("resetCourier")}
              </Button>
              <Pin
                onSubmit={(code: number[]) => {
                  onSave(undefined, parseInt(code.join("")));
                }}
              />
            </>
          )}
        </div>
      </form>
    </Modal>
  );
};
export default MapOrdersSelectModal;
